<script setup lang="ts">
import { tv } from "tailwind-variants";

const props = defineProps<{ packet: Packet }>();

provide(keys.currentPacket, toRef(() => props.packet));

const variants = tv({
  variants: {
    theme: {
      "green-seagreen": "[--hero:theme(colors.seagreen.40)] [--pitches:theme(colors.seagreen.5)]",
      "dark-red-pink": "[--hero:theme(colors.red.50)] [--pitches:theme(colors.red.35)]",
      "blue-pink": "[--hero:theme(colors.blue.60)] [--pitches:theme(colors.blue.50)]",
      "green-red": "[--hero:theme(colors.green.50)] [--pitches:theme(colors.red.10)]",
    },
  },
});

const cls = computed(() => variants({ theme: props.packet.theme }));
</script>

<template>
  <main
    id="main-content"
    :class="cls"
    class="bg-[--hero]"
  >
    <PacketHero />
    <PacketCards />
    <PacketProductsCta />
    <PacketQuote />
    <PacketPitches data-pitches class="bg-[--pitches]" />
    <PacketVideo data-video />
    <UiPacketsRelatedArticles />
    <PacketRelated />
  </main>
</template>

<style scoped>
[data-video] {
  --curtain: var(--hero);
}

[data-pitches] + [data-video] {
  --curtain: var(--pitches);
}
</style>
